module.exports = __webpack_public_path__ + "static/media/birdbrain.c7ec5257.jpg";